export const actionTypes = {
  SET_VIEWS_IDS: "VIEWS:SET_IDS",

  SET_VIEWS_PREVIEWS: "VIEWS:SET_PREVIEWS",
  SET_VIEWS_PREVIEWS_BY_PAGE: "VIEWS:SET_PREVIEWS_BY_PAGE",
  SET_VIEWS_ALL_COUNTER: "VIEWS:SET_ALL_COUNTER",
  SET_VIEWS_NEW_COUNTER: "VIEWS:SET_NEW_COUNTER",

  SET_PREVIEWS_NEW: "VIEWS:SET_PREVIEWS_NEW",
  SET_PREVIEWS_TODAY: "VIEWS:SET_PREVIEWS_TODAY",
  SET_PREVIEWS_YESTERDAY: "VIEWS:SET_PREVIEWS_YESTERDAY",
  SET_PREVIEWS_WEEK: "VIEWS:SET_PREVIEWS_WEEK",
  SET_PREVIEWS_MONTH: "VIEWS:SET_PREVIEWS_MONTH",
  SET_PREVIEWS_EARLIER: "VIEWS:SET_PREVIEWS_EARLIER",

  SET_LOADING_NEW: "VIEWS:SET_LOADING_NEW",
  SET_LOADING_TODAY: "VIEWS:SET_LOADING_TODAY",
  SET_LOADING_YESTERDAY: "VIEWS:SET_LOADING_YESTERDAY",
  SET_LOADING_WEEK: "VIEWS:SET_LOADING_WEEK",
  SET_LOADING_MONTH: "VIEWS:SET_LOADING_MONTH",
  SET_LOADING_EARLIER: "VIEWS:SET_LOADING_EARLIER",
  SET_LOADING_ALL: "VIEWS:SET_LOADING_ALL",

  ADD_VIEW_NEW: "VIEWS:ADD_NEW",
  ADD_VIEW_TODAY: "VIEWS:ADD_TODAY",
  ADD_VIEW_YESTERDAY: "VIEWS:ADD_YESTERDAY",
  ADD_VIEW_LAST_WEEK: "VIEWS:ADD_LAST_WEEK",
  ADD_VIEW_LAST_MONTH: "VIEWS:ADD_LAST_MONTH",
  ADD_VIEW_EARLIER: "VIEWS:ADD_EARLIER",


  PUSH_NEW_PREVIEW: "VIEWS:PUSH_NEW_PREVIEW",

  SET_PAGE_WAS_VISITED: "VIEWS:SET_PAGE_WAS_VISITED",
};

export type viewsIdsResponseType = {
  new: Array<number>;
  today: Array<number>;
  yesterday: Array<number>;
  lastWeek: Array<number>;
  lastMonth: Array<number>;
  earlier: Array<number>;
};

export type previewViewUserType = {
  previewUser: {
    id: string;
    name: string;
    birthday: string;
    city: {
      id: number;
      name: string;
    };
  };
  visitInfo: {
    idVisit: number;
    idVisitor: string;
    dateTimeVisit: string;
  };
};
